var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "user-center-slot",
    [
      _c(
        "user-center-container-slot",
        [
          _c("user-center-menu"),
          _vm._v(" "),
          _c(
            "user-center-content-slot",
            { attrs: { hidden: true } },
            [
              _c("user-center-content-title", { attrs: { title: "身份认证" } }),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__id-row" }, [
                _c("div", { staticClass: "user-center__id-summary" }, [
                  _c("i", {
                    staticClass:
                      "iconfont icon-_biaodan user-center__id-icon--default"
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "user-center__id-tips" }, [
                    _vm._v("认证身份信息，更好的为您服务")
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editFlag,
                          expression: "editFlag"
                        }
                      ],
                      staticClass: "user-center__id-button--primary",
                      attrs: { href: "javascript:void(0);" },
                      on: { click: _vm.onEdit }
                    },
                    [_vm._v("修改资料")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__id-tips--friendly" }, [
                _vm._v(
                  "\n        温馨提示：建议您在收到漏洞奖金支付消息通知时，及时完善您的身份认证资料，该信息用于您的漏洞奖金支付，如下的信息我们将按照法律要求和业界成熟的安全标准，为您的个人信息提供相应的安全保护措施！\n        "
                )
              ]),
              _vm._v(" "),
              _vm.isEdit
                ? _c("div", [
                    _c("div", { staticClass: "user-center__id-list" }, [
                      _c(
                        "div",
                        {
                          staticClass: "user-center__id-item is-overflow-hidden"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-center__id-item-title" },
                            [_vm._v("真实姓名:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "user-center__id-item-content is-overflow-hidden"
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.realName))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-center__id-item is-overflow-hidden"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-center__id-item-title" },
                            [_vm._v("手机号码:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "user-center__id-item-content is-overflow-hidden"
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.phoneNumber))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-center__id-item is-overflow-hidden"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-center__id-item-title" },
                            [_vm._v("身份证号:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "user-center__id-item-content is-overflow-hidden"
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.idCard))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-center__id-item is-overflow-hidden"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-center__id-item-title" },
                            [_vm._v("银行名称:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "user-center__id-item-content is-overflow-hidden"
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.bank))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-center__id-item is-overflow-hidden"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-center__id-item-title" },
                            [_vm._v("开户银行:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "user-center__id-item-content is-overflow-hidden"
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.bankName))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-center__id-item is-overflow-hidden"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-center__id-item-title" },
                            [_vm._v("银行卡号:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "user-center__id-item-content is-overflow-hidden"
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.bankCard))]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEdit
                ? _c("div", [
                    _c(
                      "div",
                      [
                        _c(
                          "xui-form",
                          {
                            ref: "ruleForm",
                            staticClass: "user-center__id-list",
                            attrs: { model: _vm.ruleForm, rules: _vm.rules }
                          },
                          [
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("真实姓名:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "realName" } },
                                    [
                                      _c("xui-input", {
                                        attrs: {
                                          placeholder: "请输入您的真实姓名"
                                        },
                                        model: {
                                          value: _vm.ruleForm.realName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "realName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.realName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("手机号码:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "phoneNumber" } },
                                    [
                                      _c("xui-input", {
                                        attrs: {
                                          placeholder: "请输入您的手机号"
                                        },
                                        model: {
                                          value: _vm.ruleForm.phoneNumber,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "phoneNumber",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.phoneNumber"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("身份证号:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "idCard" } },
                                    [
                                      _c("xui-input", {
                                        attrs: {
                                          placeholder: "请输入您的身份证号码"
                                        },
                                        model: {
                                          value: _vm.ruleForm.idCard,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "idCard",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.idCard"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("银行名称:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "bank" } },
                                    [
                                      _c("xui-input", {
                                        attrs: {
                                          placeholder: "请输入您的银行名称"
                                        },
                                        model: {
                                          value: _vm.ruleForm.bank,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "bank",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.bank"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("开户银行:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "bankName" } },
                                    [
                                      _c("xui-input", {
                                        attrs: {
                                          placeholder: "请输入您的开户银行"
                                        },
                                        model: {
                                          value: _vm.ruleForm.bankName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "bankName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.bankName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("银行卡号:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "bankCard" } },
                                    [
                                      _c("xui-input", {
                                        attrs: {
                                          placeholder: "请输入您的银行卡号"
                                        },
                                        model: {
                                          value: _vm.ruleForm.bankCard,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "bankCard",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "ruleForm.bankCard"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("身份证正面:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "idCardFrontId" } },
                                    [
                                      _c(
                                        "xui-upload",
                                        {
                                          staticClass: "idCard_upload",
                                          attrs: {
                                            "before-upload": _vm.beforUploadPic,
                                            action: "idCardFrontId",
                                            "on-error": _vm.reportError,
                                            "before-remove": _vm.triggerRemove,
                                            "http-request": _vm.uploadImg,
                                            "list-type": "picture-avatar",
                                            headers: _vm.xCsrfToken,
                                            "on-success": _vm.handlePreview,
                                            "with-credentials": true
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.ruleForm &&
                                                    _vm.ruleForm.idCardFrontId
                                                    ? "请修改身份证头像面"
                                                    : "请上传身份证头像面"
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-center__id-item" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__id-item-title is-required"
                                },
                                [_vm._v("身份证反面：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-center__id-item-content" },
                                [
                                  _c(
                                    "xui-form-item",
                                    { attrs: { prop: "idCardBackId" } },
                                    [
                                      _c(
                                        "xui-upload",
                                        {
                                          staticClass: "idCard_upload",
                                          attrs: {
                                            "before-upload": _vm.beforUploadPic,
                                            action: "idCardBackId",
                                            "on-error": _vm.reportError,
                                            "before-remove": _vm.triggerRemove,
                                            "http-request": _vm.uploadImg,
                                            "list-type": "picture-avatar",
                                            headers: _vm.xCsrfToken,
                                            "on-success": _vm.handlePreview,
                                            "with-credentials": true
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.ruleForm &&
                                                    _vm.ruleForm.idCardBackId
                                                    ? "请修改身份证国徽面"
                                                    : "请上传身份证国徽面"
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__id-submit" },
                          [
                            _c(
                              "xui-button",
                              {
                                staticClass: "user-center__id-button--bottom",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onSubmit("ruleForm")
                                  }
                                }
                              },
                              [_c("span", [_vm._v(" 提交 ")])]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.delWarnning,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.delWarnning = $event
            }
          }
        },
        [
          _c("p", { staticClass: "dialog-content" }, [
            _c(
              "span",
              [
                _vm.success
                  ? [
                      _c("img", {
                        staticClass: "img-status",
                        attrs: {
                          src: require("../../../images/settingSuccess.jpg")
                        }
                      })
                    ]
                  : [
                      _c("img", {
                        staticClass: "img-status",
                        attrs: {
                          src: require("../../../images/settingError.png")
                        }
                      })
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "dialog-content" }, [
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.success
                      ? "您的个人资料保存成功！"
                      : "您的个人资料保存失败！！"
                  ) +
                  "\n      "
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          staticClass: "warnning-wrap",
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.dialogVisible,
            width: _vm.$store.state.isMobile ? "80%" : "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "h3",
            {
              style: {
                "font-size": _vm.$store.state.isMobile ? "24px" : "16.5px"
              }
            },
            [_vm._v("荣耀安全应急响应中心服务条款")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrap",
              style: {
                "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:"
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [_vm._v("真实姓名，身份证正反面照片及身份证号；")]),
                _vm._v(" "),
                _c("li", [_vm._v("银行卡号，开户行信息，银行名称；")]),
                _vm._v(" "),
                _c("li", [_vm._v("手机号码，邮寄地址；")]),
                _vm._v(" "),
                _c("li", [_vm._v("昵称，头像，邮箱，主页；")]),
                _vm._v(" "),
                _c("li", [_vm._v("QQ，微信，签名，团队；")]),
                _vm._v(" "),
                _c("li", [_vm._v("IP地址；")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "上述数据将会传输并保存至位于中华人民共和国境内的服务器。"
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v("点击“同意”，即表示您同意\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-user-protocol",
                    attrs: { href: _vm.safetyURL, target: "_blank" }
                  },
                  [_vm._v("荣耀安全应急响应中心用户协议")]
                ),
                _vm._v("\n        ，并知悉\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-secret-statement",
                    attrs: { href: _vm.privacyURL, target: "_blank" }
                  },
                  [_vm._v("关于安全应急响应中心与隐私的声明")]
                ),
                _vm._v("。")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", center: "" },
              slot: "footer"
            },
            [
              _c(
                "xui-button",
                { attrs: { size: "bigger" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("同意")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isNotLogin && _vm.isEffect
        ? _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "失效提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("您的账号已经失效，请联系管理员")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ]
          )
        : _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "登录提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("系统检测到您未登录或登录失效，请先登录")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.login }
                    },
                    [_vm._v("荣耀账号登录")]
                  )
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-059317da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-059317da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/idinfo/usercenterIdInfo.vue
// module id = null
// module chunks = 